"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardModule = void 0;
// import * as Chart from 'chart.js';
// import { observable, toJS } from 'mobx';
const react_1 = require("react");
const React = require("react");
const paper_1 = require("client/components/material/paper");
const store_1 = require("client/modules/users/store");
const widget_grid_1 = require("./modules/widget-grid");
require("./dashboard.less");
require("./intent-reversal-alerts.less");
class DashboardModule extends react_1.Component {
    render() {
        return (React.createElement("div", { className: "dashboard" }, store_1.usersStore.permissions.ReadDashboard ? (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "dashboard__title" },
                React.createElement("h1", { className: "dashboard__title--label" }, "Dashboard")),
            React.createElement(paper_1.MaterialPaperDashboard, { noMargin: true, className: "dashboard__content" },
                React.createElement(widget_grid_1.WidgetGrid, null)))) : (store_1.usersStore.showLock())));
    }
}
exports.DashboardModule = DashboardModule;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/dashboard.tsx
// module id = 3285
// module chunks = 0